import axios from 'axios';
import { Notification } from 'element-ui';
import { GetAuthToken } from 'rj-server-auth-token';
import { jumpShutDownPage } from '@/libs/util';
import { getSign } from './requestEncryption';
import Cookies from 'js-cookies';

// let querystring = require('querystring');
// 允许跨域请求发送cookie
let CreditAxios = axios.create();

CreditAxios.defaults.withCredentials = true;
CreditAxios.defaults.baseURL = `${window._env_.CREDITCONTROL_APIBASE_URL}/`;
// axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/order-lifecycle-uat02' : '/order-lifecycle-uat02';
CreditAxios.defaults.headers.post['Content-Type'] = 'application/json'; // application/x-www-form-urlencoded , multipart/form-data
// http请求拦截
CreditAxios.interceptors.request.use(
  config => {
    // if (config.headers.common.Accept.indexOf('application/json') >= 0) {
    //   // config.data = querystring.stringify(config.data);
    //   console.log(config);
    //
    // }
    config.headers['web-sign-server-auth'] = GetAuthToken({
      sysId: '6ff2a8ed94de46aca1f5dc996169a424',
      accessKeySecret: '4D0E6C351B5740BE84960FEC53CC9E84'
    });
    config.headers['sysId'] = '6ff2a8ed94de46aca1f5dc996169a424';
    config.headers['timeOut'] = new Date().getTime();
    config.headers['sid_login'] = localStorage.getItem('sidLogin') && JSON.parse(localStorage.getItem('sidLogin') || '');
    config.headers['union_session_ticket'] = localStorage.getItem('union_session_ticket');

    let timestamp = localStorage.getItem('timestamp');
    if (timestamp && timestamp + 600000 > new Date().getTime()) {
      timestamp = new Date().getTime();
      localStorage.setItem('timestamp', timestamp);
    } else {
      timestamp = new Date().getTime();
    }
    const sign = getSign(config, axios, timestamp);
    config.headers['sign'] = sign;
    config.headers['timestamp'] = timestamp;

    return config;
  },

  error => {
    return Promise.reject(error);
  }
);

// http响应拦截器
CreditAxios.interceptors.response.use(
  res => {
    // 停机维护
    if (res.data && res.data.status === '503') {
      jumpShutDownPage(res.data.data);
    }

    const contentType = (res.headers && res.headers['content-type']) || '';
    if (contentType.indexOf('application/octet-stream') >= 0) {
      return res;
    }

    let json = res.data;
    // 文件流响应（Blob）直接返回，不做业务状态码校验
    if (json instanceof Blob) {
      return res;
    }
    if (json && json.status !== '200' && json && json.status !== '302') {
      Notification.error({
        message: json.error || json.err
      });
    } else if (json && json.status === '302') {

    }
    return res;
  },
  error => {
    if (error.message.includes('428')) {
      Cookies.removeItem('ruijieportal', '/', '.ruijie.com.cn');
      Cookies.removeItem('PartnerUser', '/', '.ruijie.com.cn');
      Cookies.removeItem('phplogin', '/', '.ruijie.com.cn');
      Cookies.removeItem('thh_auth', '/', '.ruijie.com.cn');
      Cookies.removeItem('sid_login', '/', '.ruijie.com.cn');
      // 干掉切换的渠道
      Cookies.removeItem('xsyx_chang_user', '/', '.ruijie.com.cn');
      window.localStorage.removeItem('union_session_ticket');
      if (window._env_.NODE_ENV !== 'pro') {
        window.location.href = `${window.location.origin}/toLoginPage`;
      } else {
        window.location.href = `https://ces.ruijie.com.cn/toLoginPage`;
      }
      // return Notification.warning({
      //   message: '登录验证失败或登录已失效，请重新登录'
      // });
    }
    Notification.error({
      message: (error.response && error.response.err) || '请求服务器失败'
    });
    return Promise.reject(error);
  }
);
// axios 具体使用 请参考 https://github.com/axios/axios
export default axios;
// 获取我的申请列表信息
export const getCreditControlList = (params) => CreditAxios.post(`/credit-control-api/creditInfo/getCreditControlList`, params);
// 废弃我的申请
export const abandonedCreditControl = (orderId) => CreditAxios.put(`/credit-control-api/creditInfo/abandonedCreditControl/${orderId}`);
// 召回我的申请
export const retrieveCreditControl = (params) => CreditAxios.post(`/credit-control-api/creditInfo/retrieveCreditControl`, params);
// 生成单据编号
export const numberGeneration = (params) => CreditAxios.get(`/credit-control-api/creditInfo/numberGeneration`, { params });
// 获取审批页信息
export const getCreditControl = (params) => CreditAxios.get('/credit-control-api/creditInfo/getCreditControl', { params });
// 获取客户主数据
export const getEnterpriseBaseInfoAccurate = (params) => CreditAxios.get(`/credit-control-api/creditInfo/getEnterpriseBaseInfoAccurate`, { params });
// 提交信控申请
export const saveCreditControlInfoApplicant = (params) => CreditAxios.post(`/credit-control-api/creditInfo/saveCreditControlInfoApplicant`, params);
// 保存信控申请
export const saveCreditControlInfoApplicantDraft = (params) => CreditAxios.post(`/credit-control-api/creditInfo/saveCreditControlInfoApplicantDraft`, params);
// 获取文件服务token
export const getFileToken = () => CreditAxios.get('/op-api/api/v1/attachment/getToken');
// 单个下载export
export const downloadUrl = (fileServerId) => CreditAxios.get(`/credit-control-api/attachment/download-url/${fileServerId}`);
// 查询客户信息
export const searchCustomer = (customerName) => CreditAxios.get(`/credit-control-api/manage/accountPeriod/searchCustomer/${customerName}`);
// 获取当前全部审批人带状态
export const getOrderCheckListNew = (params) => CreditAxios.get(`/credit-control-api/creditInfo/getOrderCheckListNew`, { params });
// 模糊查询获取商务列表
export const getBusinessList = (key) => CreditAxios.get(`/credit-control-api/creditInfo/getBusinessList?key=${key}`);
// 信用额度查询
export const getCreditMoneyDataList = (key) => CreditAxios.get(`/credit-control-api/creditInfo/getCreditMoney`);
